/**
 * Backend-served media (FileField URLs like `/media/schools/…`) is hosted on
 * the API origin, not the SPA origin. Lesson-block read enrichment
 * (curriculum/blocks.py `build_read_blocks`) returns such relative paths —
 * resolve them against the API origin derived from `VITE_API_URL`.
 */

const apiUrl = import.meta.env.VITE_API_URL ?? '/api';

/** Origin of the API (e.g. `https://api.osvitly.com`), or '' when the API URL
 *  is itself relative (same-origin deploys — relative media paths just work). */
function apiOrigin(): string {
  try {
    return new URL(apiUrl).origin;
  } catch {
    return '';
  }
}

/** Absolute URL for a backend media path; absolute inputs pass through. */
export function mediaUrl(pathOrUrl: string): string {
  if (!pathOrUrl || /^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${apiOrigin()}${pathOrUrl}`;
}
